import axios from 'axios';

export const FETCH_GAMES_REQUEST = 'FETCH_GAMES_REQUEST';
export const FETCH_GAMES_SUCCESS = 'FETCH_GAMES_SUCCESS';
export const FETCH_GAMES_FAILURE = 'FETCH_GAMES_FAILURE';
export const ADD_GAME_SUCCESS = 'ADD_GAME_SUCCESS';
export const UPDATE_GAME_SUCCESS = 'UPDATE_GAME_SUCCESS';
export const TOGGLE_GAME_STATUS_SUCCESS = 'TOGGLE_GAME_STATUS_SUCCESS';
export const DELETE_GAME_SUCCESS = 'DELETE_GAME_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getGames = () => async (dispatch) => {
  dispatch({ type: FETCH_GAMES_REQUEST });
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'game',
      command: 'getGames'
    });
    const status = response.data?.status;
    if (status && status !== 200) {
      throw new Error(response.data?.message || 'Failed to fetch games');
    }
    dispatch({
      type: FETCH_GAMES_SUCCESS,
      payload: response.data.data || []
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_GAMES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch games'
    });
  }
};

export const createGame = (gameData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'game',
      command: 'createGame',
      ...gameData
    });
    const status = response.data?.status;
    if (status && status !== 200 && status !== 201) {
      throw new Error(response.data?.message || 'Failed to create game');
    }
    dispatch({
      type: ADD_GAME_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create game:', error);
    throw error;
  }
};

export const updateGame = ({ gameId, updateData }) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'game',
      command: 'updateGame',
      gameId, // Pass `gameId` directly as a string
      updateData, // Pass `updateData` as a separate field
    });
    const status = response.data?.status;
    if (status && status !== 200) {
      throw new Error(response.data?.message || 'Failed to update game');
    }
    dispatch({
      type: UPDATE_GAME_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update game:', error);
    throw error;
  }
};

export const toggleGameStatus = (gameId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'game',
      command: 'toggleGameStatus',
      gameId
    });
    dispatch({
      type: TOGGLE_GAME_STATUS_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to toggle game status:', error);
    throw error;
  }
};

export const deleteGame = (gameId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'game',
      command: 'deleteGame',
      gameId
    });
    dispatch({
      type: DELETE_GAME_SUCCESS,
      payload: gameId
    });
    return response.data;
  } catch (error) {
    console.error('Failed to delete game:', error);
    throw error;
  }
};